<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>训练软件客户管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane name="first" label="清单列表">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.loginname" @keyup.enter.native="clicksearch" placeholder="请输入登录账号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.nicename" @keyup.enter.native="clicksearch" placeholder="请输入昵称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Id" label="ID" min-width="5%"></el-table-column>
          <el-table-column prop="Loginname" label="登录账号" min-width="20%"></el-table-column>
          <el-table-column prop="Nicename" label="昵称" min-width="20%"></el-table-column>
          <el-table-column prop="Beizhu" label="备注" min-width="20%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="20%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="20%">
            <template slot-scope="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickeditrole(scope.$index,scope.row)">编辑</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickpermissions(scope.$index,scope.row)">权限设置</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 编辑弹出框 start -->
        <el-dialog title="编辑" :visible.sync="editInfo" width="30%" :close-on-click-modal="false">
          <el-form :model="editForm" ref="addAaminFormRef" label-width="70px">
            <input v-model="editForm.roleid" type="hidden"></input>

            <el-form-item label="昵称" class="addAdminForm">
                <el-input v-model="editForm.nicename" placeholder="请输入昵称"></el-input>
            </el-form-item>

            <el-form-item label="备注" class="addAdminForm">
                <el-input type="textarea" v-model="editForm.beizhu" placeholder="请输入备注"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="funeditrole">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 编辑角色弹出框 end -->

        <!-- 权限设置弹出框 start -->
        <el-dialog :title="edittitle" :visible.sync="permissionSettings" width="40%" :close-on-click-modal="false">
          <el-tree
            :data="menudata"
            :default-checked-keys="defaultcheckedkeys"
            show-checkbox
            :default-expand-all="true"
            node-key="id"
            ref="tree"
            highlight-current
            :props="defaultProps"
            :accordion="true">
          </el-tree>
          <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="clicksavepermissions">保存</el-button>
          </span>
        </el-dialog>
        <!-- 权限设置弹出框 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->
    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyRole',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        loginname: '',
        nicename: ''
      },
      editForm: {
        id: 0,
        nicename: '',
        beizhu: ''
      },
      defaultcheckedkeys: [],
      editInfo: false,
      permissionSettings: false,
      menudata: [],
      editPermissionsId: 0,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      edittitle:'权限设置'
    }
  },
  mounted () {
    this.apiGetXunLianUsersNum()
    this.apiGetXunLianUsersList()
  },
  methods: {
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetXunLianUsersList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetXunLianUsersNum()
      this.apiGetXunLianUsersList()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickeditrole (index, row) {
      this.editForm.id = row.Id
      this.editForm.nicename = row.Nicename
      this.editForm.beizhu = row.Beizhu
      this.editInfo = true
    },
    clickpermissions (index, row) {
      this.editPermissionsId = row.Id
      this.edittitle = row.Nicename
      this.apiGetXunLianUsersPermissions(row.Id)
    },
    clicksavepermissions () {
      this.apiEditXunLianUsersPermissions(this.editPermissionsId, this.$refs.tree.getCheckedKeys().toString())
    },
    funeditrole () {
      this.apiEditXunLianUsers()
    },
    apiGetXunLianUsersList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        loginname: that.keywords.loginname,
        nicename: that.keywords.nicename
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetXunLianUsersList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetXunLianUsersNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname,
        nicename: that.keywords.nicename
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetXunLianUsersNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditXunLianUsers: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var parentid = 0
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.editForm.id,
        nicename: this.editForm.nicename,
        beizhu: this.editForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditXunLianUsers, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.editInfo = false
            that.apiGetXunLianUsersNum()
            that.apiGetXunLianUsersList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetXunLianUsersPermissions: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetXunLianUsersPermissions, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.menudata = []
            response.data.Listmenu.filter((item1, i1) => {
              var list2 = []
              item1.List.filter((item2, i2) => {
                var list3 = []
                item2.List.filter((item3, i3) => {
                  list3.push({ id: item3.Id, label: item3.Authname, children: '' })
                })
                if (list3.length == 0) list3 = ''
                list2.push({ id: item2.Id, label: item2.Authname, children: list3 })
              })
              if (list2.length == 0) list2 = ''
              that.menudata.push({ id: item1.Id, label: item1.Authname, children: list2 })
            })
            that.defaultcheckedkeys = []
            response.data.Listpermissions.filter((item, i) => {
              that.defaultcheckedkeys.push(item.Menuid)
            })
            that.permissionSettings = true
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditXunLianUsersPermissions: function (xunlianuserid, permissions) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var parentid = 0
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        xunlianuserid: xunlianuserid,
        permissions: permissions
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditXunLianUsersPermissions, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.permissionSettings = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.el-tree{
  height: 350px;
  overflow-y: scroll
}
.el-tree::-webkit-scrollbar {
    display: none;
}
</style>
